module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_1000_5000.7fa5a184.png";